import { baseUrl } from '@/baseUrl';
import axios from 'axios';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      name: null,
      id: null,
      email: null,
      affiliate: null,
    },
    suppliers: [],
  },
  mutations: {
    SET_USER(state, data) {
      state.user = data;
    },
    SET_SUPPLIERS(state, data) {
      state.suppliers = data;
    },
  },
  actions: {
    setUser({ commit }, user) {
      commit("SET_USER", user);
    },
    resetUser({ commit }) {
      commit("SET_USER", {
        name: null,
        id: null,
        email: null,
        affiliate: null,
      });
    },
    async fillSuppliersIfEmpty({ commit }) {
      if (this.state.user.id && this.state.suppliers.length < 1) {
        const response = await fetch(
          `${baseUrl}/v2/leverancier/userId/${this.state.user.id}`,
          {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
          }
        );
        commit("SET_SUPPLIERS", await response.json());
      } else if (!this.state.user.id) {
        commit("SET_SUPPLIERS", []);
      }
    },
    async refillSuppliers({ commit }) {
      if (this.state.user.id) {
        const response = await fetch(
          `${baseUrl}/v2/leverancier/userId/${this.state.user.id}`,
          {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
          }
        );

        commit("SET_SUPPLIERS", await response.json());
      } else if (!this.state.user.id) {
        commit("SET_SUPPLIERS", []);
      }
    },
    async isAuthenticated({ commit }) {
      const response = await axios.get(`${baseUrl}/v2/auth`);
      const user = response.data;
      console.log("USER", user)

      if (user.role === 'leverancier') {
        commit('SET_USER', response.data)
        this.dispatch("fillSuppliersIfEmpty");
      }
      else commit("SET_USER", {
        name: null,
        id: null,
        email: null,
        affiliate: null,
      })
    }
  },
  modules: {
  },
  getters: {
    user(state) {
      return state.user;
    },
    suppliers(state) {
      return state.suppliers;
    },
  },
})